import { render, staticRenderFns } from "./KoioteIBHLinkConnection.vue?vue&type=template&id=52a5f93c&lang=es&"
import script from "./KoioteIBHLinkConnection.vue?vue&type=script&lang=js&"
export * from "./KoioteIBHLinkConnection.vue?vue&type=script&lang=js&"
import style0 from "./KoioteIBHLinkConnection.vue?vue&type=style&index=0&id=52a5f93c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports